import Vue from 'vue'

export default function setTransactions({ itemId, transactions }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/items/" + itemId + "/transactions"
    return Vue.http
        .post(url, transactions, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch(() => { throw "Ошибка сохранения" })
}